const stylesConfig = {
	shadowNormal: 'rgba(0, 0, 0, 0.35) 0px 5px 15px;',
	shadowThin: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',

	colorPrimary: 'hsl(217, 84%, 39%)',
	colorPrimaryLight1: 'hsl(217, 84%, 43%)',

	colorSecondary: 'hsl(338, 100%, 38%)',
	colorSecondaryLight1: 'hsl(338, 100%, 43%)',

	colorGrey1: 'hsl(0, 0%, 87%)',
	colorGrey2: 'hsl(0, 0%, 60%)',
	colorGrey3: 'hsl(0, 0%, 43%)',
	colorGrey4: 'hsl(0, 0%, 34%)',

	colorBlack: 'hsl(0, 0%, 7.5%)',

	inputFocusStyle: '0 0 0 1px rgb(16, 80, 183)',

	// 1800px
	bpExtraLarge: '112.5em',
	// 1200px
	bpLarge: '75em',
	// 850px
	bpMedium: '53.12em',
	// 550px
	bpSmall: '34.4em',
	// 350px
	bpExtraSmall: '21.8em',
};

export default stylesConfig;
